// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home-layout {
  min-height: 100vh;
  background: var(--color-bg);
}

.home-content {
  padding: 24px 0;
  min-height: calc(100vh - 200px);
}

.content-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
}

.content-container.home-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  width: 100%;
}

/* 移动端和PAD端使用固定高度布局 */
@media (max-width: 768px) {
  .home-layout {
    height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }

  .home-content {
    flex: 1 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    padding: 0;
  }

  .content-container.home-container {
    flex: 1 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
}

/* 主要游戏区域 */
.games-main {
  width: 100%;
}

/* 移动端和PAD端的滚动区域 */
@media (max-width: 768px) {
  .games-main {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 24px 0;
  }
}

.games-grid {
  margin-bottom: 40px;
}

/* 列表中的广告位样式 */
.ad-in-list {
  margin: 20px 0;
  padding: 16px;
  background: var(--color-bg-white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-sm);
  text-align: center;
}

.ad-in-list .ad-container {
  margin: 0;
}

.ad-in-list .ad-content {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 90px;
}



/* 滚动加载指示器 */
.scroll-loading-container {
  text-align: center;
  padding: 20px 0;
  margin: 20px 0;
}

.scroll-loading-container .loading-text {
  margin-top: 12px;
  color: #666;
  font-size: 14px;
}

/* 滚动加载指示器在所有平台显示 */





.pagination-container {
  margin-top: 40px;
  text-align: center;
  padding: 24px;
  background: var(--color-bg-white);
  border-radius: var(--border-radius-lg);
  box-shadow: var(--shadow-sm);
}

.sidebar {
  position: sticky;
  top: 88px;
}

.popular-card {
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.sidebar-title {
  margin-bottom: 16px !important;
  color: #262626;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
}

.popular-item {
  padding: 12px 0;
  border-bottom: 1px solid #f0f0f0;
  transition: background-color 0.3s ease;
}

.popular-item:last-child {
  border-bottom: none;
}

.popular-item:hover {
  background-color: #f9f9f9;
  border-radius: 8px;
  margin: 0 -8px;
  padding: 12px 8px;
}

.rank-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: linear-gradient(135deg, #1890ff, #40a9ff);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: bold;
}

.popular-item:nth-child(1) .rank-number {
  background: linear-gradient(135deg, #ff4d4f, #ff7875);
}

.popular-item:nth-child(2) .rank-number {
  background: linear-gradient(135deg, #fa8c16, #ffa940);
}

.popular-item:nth-child(3) .rank-number {
  background: linear-gradient(135deg, #faad14, #ffc53d);
}

.popular-app-name {
  color: #262626;
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  transition: color 0.3s ease;
}

.popular-app-name:hover {
  color: #1890ff;
}

.popular-app-info {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
}

.popular-app-info .category {
  color: #1890ff;
  background: #e6f7ff;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
}

.popular-app-info .click-count {
  color: #666;
  font-size: 11px;
}

/* 新的热门排行布局样式 */
.popular-item-content {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.popular-item-left {
  flex-shrink: 0;
}

.popular-app-icon {
  border-radius: 8px !important;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.popular-item-right {
  flex: 1 1;
  min-width: 0;
}

.popular-app-title {
  margin-bottom: 8px;
}

.popular-app-title .popular-app-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

.popular-app-stats {
  display: flex;
  align-items: center;
}

.popular-app-stats .ant-space {
  width: 100%;
  justify-content: flex-start;
}

.popular-app-stats .ant-space-item {
  flex-shrink: 1;
  min-width: 0;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 2px;
  font-size: 11px;
  color: #666;
  min-width: 0;
  flex-shrink: 1;
}

.stat-icon {
  font-size: 10px;
  color: #999;
  flex-shrink: 0;
}

.stat-value {
  font-weight: 500;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
}

@media (max-width: 768px) {
  .content-container.home-container {
    padding: 0 16px;
  }

  .games-main {
    padding: 16px 0;
  }

  /* 滚动加载指示器在所有平台显示 */


}

@media (max-width: 480px) {
  .content-container.home-container {
    padding: 0 12px;
  }

  .games-main {
    padding: 12px 0;
    /* 调整top值以适应Header(56px) + MobileCategoryNav(约56px) */
    padding-top: 16px;
  }

  .games-grid {
    margin-bottom: 24px;
  }

  .scroll-loading-container {
    padding: 16px 0;
    margin: 16px 0;
  }

  .scroll-loading-container .loading-text {
    font-size: 13px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home/Home.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,WAAW;AACb;;AAEA,qBAAqB;AACrB;EACE;IACE,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,gBAAgB;EAClB;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;EACxB;AACF;;AAEA,WAAW;AACX;EACE,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE;IACE,SAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;EACjB;AACF;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,cAAc;EACd,aAAa;EACb,iCAAiC;EACjC,sCAAsC;EACtC,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;;;AAIA,YAAY;AACZ;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,mBAAmB;;;;;;AAMnB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,iCAAiC;EACjC,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA,mBAAmB;;;AAGrB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,qDAAqD;IACrD,iBAAiB;EACnB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".home-layout {\n  min-height: 100vh;\n  background: var(--color-bg);\n}\n\n.home-content {\n  padding: 24px 0;\n  min-height: calc(100vh - 200px);\n}\n\n.content-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n}\n\n.content-container.home-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 24px;\n  width: 100%;\n}\n\n/* 移动端和PAD端使用固定高度布局 */\n@media (max-width: 768px) {\n  .home-layout {\n    height: 100vh;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n  }\n\n  .home-content {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    padding: 0;\n  }\n\n  .content-container.home-container {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n  }\n}\n\n/* 主要游戏区域 */\n.games-main {\n  width: 100%;\n}\n\n/* 移动端和PAD端的滚动区域 */\n@media (max-width: 768px) {\n  .games-main {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: hidden;\n    padding: 24px 0;\n  }\n}\n\n.games-grid {\n  margin-bottom: 40px;\n}\n\n/* 列表中的广告位样式 */\n.ad-in-list {\n  margin: 20px 0;\n  padding: 16px;\n  background: var(--color-bg-white);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-sm);\n  text-align: center;\n}\n\n.ad-in-list .ad-container {\n  margin: 0;\n}\n\n.ad-in-list .ad-content {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  min-height: 90px;\n}\n\n\n\n/* 滚动加载指示器 */\n.scroll-loading-container {\n  text-align: center;\n  padding: 20px 0;\n  margin: 20px 0;\n}\n\n.scroll-loading-container .loading-text {\n  margin-top: 12px;\n  color: #666;\n  font-size: 14px;\n}\n\n/* 滚动加载指示器在所有平台显示 */\n\n\n\n\n\n.pagination-container {\n  margin-top: 40px;\n  text-align: center;\n  padding: 24px;\n  background: var(--color-bg-white);\n  border-radius: var(--border-radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.sidebar {\n  position: sticky;\n  top: 88px;\n}\n\n.popular-card {\n  border-radius: 12px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.sidebar-title {\n  margin-bottom: 16px !important;\n  color: #262626;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 18px;\n}\n\n.popular-item {\n  padding: 12px 0;\n  border-bottom: 1px solid #f0f0f0;\n  transition: background-color 0.3s ease;\n}\n\n.popular-item:last-child {\n  border-bottom: none;\n}\n\n.popular-item:hover {\n  background-color: #f9f9f9;\n  border-radius: 8px;\n  margin: 0 -8px;\n  padding: 12px 8px;\n}\n\n.rank-number {\n  width: 24px;\n  height: 24px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #1890ff, #40a9ff);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  font-weight: bold;\n}\n\n.popular-item:nth-child(1) .rank-number {\n  background: linear-gradient(135deg, #ff4d4f, #ff7875);\n}\n\n.popular-item:nth-child(2) .rank-number {\n  background: linear-gradient(135deg, #fa8c16, #ffa940);\n}\n\n.popular-item:nth-child(3) .rank-number {\n  background: linear-gradient(135deg, #faad14, #ffc53d);\n}\n\n.popular-app-name {\n  color: #262626;\n  font-weight: 500;\n  font-size: 14px;\n  text-decoration: none;\n  transition: color 0.3s ease;\n}\n\n.popular-app-name:hover {\n  color: #1890ff;\n}\n\n.popular-app-info {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 12px;\n}\n\n.popular-app-info .category {\n  color: #1890ff;\n  background: #e6f7ff;\n  padding: 2px 6px;\n  border-radius: 4px;\n  font-size: 11px;\n}\n\n.popular-app-info .click-count {\n  color: #666;\n  font-size: 11px;\n}\n\n/* 新的热门排行布局样式 */\n.popular-item-content {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.popular-item-left {\n  flex-shrink: 0;\n}\n\n.popular-app-icon {\n  border-radius: 8px !important;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\n}\n\n.popular-item-right {\n  flex: 1;\n  min-width: 0;\n}\n\n.popular-app-title {\n  margin-bottom: 8px;\n}\n\n.popular-app-title .popular-app-name {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: block;\n}\n\n.popular-app-stats {\n  display: flex;\n  align-items: center;\n}\n\n.popular-app-stats .ant-space {\n  width: 100%;\n  justify-content: flex-start;\n}\n\n.popular-app-stats .ant-space-item {\n  flex-shrink: 1;\n  min-width: 0;\n}\n\n.stat-item {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n  font-size: 11px;\n  color: #666;\n  min-width: 0;\n  flex-shrink: 1;\n}\n\n.stat-icon {\n  font-size: 10px;\n  color: #999;\n  flex-shrink: 0;\n}\n\n.stat-value {\n  font-weight: 500;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  min-width: 0;\n}\n\n@media (max-width: 768px) {\n  .content-container.home-container {\n    padding: 0 16px;\n  }\n\n  .games-main {\n    padding: 16px 0;\n  }\n\n  /* 滚动加载指示器在所有平台显示 */\n\n\n}\n\n@media (max-width: 480px) {\n  .content-container.home-container {\n    padding: 0 12px;\n  }\n\n  .games-main {\n    padding: 12px 0;\n    /* 调整top值以适应Header(56px) + MobileCategoryNav(约56px) */\n    padding-top: 16px;\n  }\n\n  .games-grid {\n    margin-bottom: 24px;\n  }\n\n  .scroll-loading-container {\n    padding: 16px 0;\n    margin: 16px 0;\n  }\n\n  .scroll-loading-container .loading-text {\n    font-size: 13px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
